var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.template)?_c(_vm.template,{ref:"self",tag:"component"}):_vm._e(),_vm._v(" "),_c('wait-for',{attrs:{"once":true,"target":_vm.target},on:{"target-found":_vm.handleTargetFoundListener}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }